/**
 * Gods of Tao — Theme JavaScript
 * Sacred Tools of the Tao | godsoftao.com
 */

document.addEventListener('DOMContentLoaded', function () {
  initMobileNav();
  initSmoothScroll();
  initFadeInAnimations();
  initFaqAccordion();
});

/* ── Mobile Navigation Toggle ── */
function initMobileNav() {
  const toggle = document.querySelector('.nav-toggle');
  const nav = document.querySelector('.site-nav');
  const overlay = document.querySelector('.nav-overlay');

  if (!toggle || !nav) return;

  function open() {
    nav.classList.add('nav--open');
    toggle.classList.add('nav-toggle--active');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    if (overlay) overlay.classList.add('nav-overlay--visible');
  }

  function close() {
    nav.classList.remove('nav--open');
    toggle.classList.remove('nav-toggle--active');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (overlay) overlay.classList.remove('nav-overlay--visible');
  }

  toggle.addEventListener('click', function () {
    nav.classList.contains('nav--open') ? close() : open();
  });

  if (overlay) {
    overlay.addEventListener('click', close);
  }

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav.classList.contains('nav--open')) {
      close();
    }
  });

  // Close on resize to desktop
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (window.innerWidth >= 768) close();
    }, 200);
  });
}

/* ── Smooth Scroll ── */
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');
      if (targetId === '#') return;

      const target = document.querySelector(targetId);
      if (!target) return;

      e.preventDefault();

      const headerOffset = 80;
      const elementPosition = target.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });

      // Update URL hash without jump
      history.pushState(null, null, targetId);
    });
  });
}

/* ── Fade-In Animations (IntersectionObserver) ── */
function initFadeInAnimations() {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.fade-in, .fade-in-up, .fade-in-left, .fade-in-right').forEach(function (el) {
      el.classList.add('visible');
    });
    return;
  }

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.15,
      rootMargin: '0px 0px -50px 0px'
    }
  );

  document.querySelectorAll('.fade-in, .fade-in-up, .fade-in-left, .fade-in-right, .animate-on-scroll').forEach(function (el) {
    observer.observe(el);
  });
}

/* ── FAQ Accordion Toggle ── */
function initFaqAccordion() {
  document.querySelectorAll('.faq-item').forEach(function (item) {
    const question = item.querySelector('.faq-question');
    if (!question) return;

    question.addEventListener('click', function () {
      const isOpen = item.classList.contains('faq-item--open');

      // Close all siblings (optional — single open)
      // item.parentElement.querySelectorAll('.faq-item--open').forEach(function (openItem) {
      //   if (openItem !== item) openItem.classList.remove('faq-item--open');
      // });

      item.classList.toggle('faq-item--open');

      // Update aria-expanded
      const button = question.closest('button') || question;
      if (button.hasAttribute('aria-expanded')) {
        button.setAttribute('aria-expanded', !isOpen);
      }

      // Animate answer height
      const answer = item.querySelector('.faq-answer');
      if (answer) {
        if (!isOpen) {
          answer.style.maxHeight = answer.scrollHeight + 'px';
        } else {
          answer.style.maxHeight = '0';
        }
      }
    });

    // Set initial state
    const button = question.closest('button') || question;
    if (button.hasAttribute('aria-expanded')) {
      button.setAttribute('aria-expanded', item.classList.contains('faq-item--open'));
    }
  });
}

/* ── Contact Form Handler ── */
function initContactForm() {
  const form = document.querySelector('.contact-form');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    // Simple client-side validation
    const required = form.querySelectorAll('[required]');
    let valid = true;

    required.forEach(function (field) {
      const errorEl = field.closest('.form-group').querySelector('.form-error');
      if (!field.value.trim()) {
        valid = false;
        field.classList.add('input--error');
        if (errorEl) errorEl.style.display = 'block';
      } else {
        field.classList.remove('input--error');
        if (errorEl) errorEl.style.display = 'none';
      }
    });

    // Validate email format
    const emailField = form.querySelector('input[type="email"]');
    if (emailField && emailField.value.trim()) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(emailField.value.trim())) {
        valid = false;
        emailField.classList.add('input--error');
        const errorEl = emailField.closest('.form-group').querySelector('.form-error');
        if (errorEl) {
          errorEl.style.display = 'block';
          errorEl.textContent = 'Please enter a valid email address.';
        }
      }
    }

    if (!valid) return;

    // Show thank-you / success state
    const submitBtn = form.querySelector('button[type="submit"], .form-submit');
    const thankYou = form.querySelector('.form-thank-you') || createThankYouElement(form);

    // Hide the form fields
    form.querySelectorAll('.form-group, .form-submit').forEach(function (el) {
      el.style.display = 'none';
    });

    // Show thank you
    thankYou.style.display = 'block';

    // Optionally submit via fetch (uncomment if you add a backend endpoint)
    // const formData = new FormData(form);
    // fetch(form.action, { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
    //   .catch(function () { /* fallback handled above */ });

    // Reset form for next use
    setTimeout(function () {
      form.reset();
      form.querySelectorAll('.form-group, .form-submit').forEach(function (el) {
        el.style.display = '';
      });
      thankYou.style.display = 'none';
    }, 5000);
  });
}

/* ── Helper: Create thank-you element ── */
function createThankYouElement(form) {
  const div = document.createElement('div');
  div.className = 'form-thank-you';
  div.style.display = 'none';
  div.innerHTML =
    '<div class="form-thank-you__icon" aria-hidden="true">&#10003;</div>' +
    '<h3 class="form-thank-you__title">Thank You</h3>' +
    '<p class="form-thank-you__message">Your message has been received. We will respond within 1–2 business days.</p>' +
    '<p class="form-thank-you__blessing">May peace be with you. &#9775;</p>';
  form.appendChild(div);
  return div;
}
